/* Users search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface ISearchFiltersUsersState {
    keyword: string;
    filterMode: any;    
}

const initialState: ISearchFiltersUsersState = {
    keyword: '',
    filterMode: 1,    
};

export function searchFiltersUsersReducer(state: ISearchFiltersUsersState = initialState, action: any): ISearchFiltersUsersState {
    switch (action.type) {
        case Actions.SEARCH_USERS_KEYWORD:
            return _.merge({}, state, { keyword: action.keyword });
        case Actions.SEARCH_USERS_FILTER_MODE:
            return _.merge({}, state, { filterMode: action.value });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersUsersReducer.tsx